module.exports = "/logo-white-0d0efd982bf9d4aa31647d6c84795f69.svg";